import * as Sentry from '@sentry/react';

export const hasAudioUrl = (url) =>
  !!(url !== undefined && url !== null && typeof url !== 'object' && String(url).trim().length > 0);

export const resolveAudioUrl = (url) => (hasAudioUrl(url) ? String(url).trim() : '');

const getExtensionFromContentType = (contentType) => {
  if (!contentType) return 'mp3';
  if (contentType.includes('audio/wav')) return 'wav';
  if (contentType.includes('audio/ogg')) return 'ogg';
  if (contentType.includes('audio/webm')) return 'webm';
  if (contentType.includes('audio/mp4') || contentType.includes('audio/m4a')) return 'm4a';
  if (contentType.includes('audio/mp3') || contentType.includes('audio/mpeg')) return 'mp3';
  return 'mp3';
};

export const resolveAudioFileName = (audioUrl, contentType) => {
  try {
    const audioUrlObj = new URL(audioUrl);
    const pathParts = audioUrlObj.pathname.split('/');
    const lastPart = decodeURIComponent(pathParts[pathParts.length - 1]);
    if (lastPart && lastPart.includes('.') && lastPart.split('.').pop().length <= 5) {
      return lastPart;
    }
    const extension = getExtensionFromContentType(contentType);
    return `audio_${new Date().toISOString().split('T')[0]}.${extension}`;
  } catch {
    return `audio_${new Date().toISOString().split('T')[0]}.mp3`;
  }
};

const triggerBlobDownload = (blob, fileName) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

const openAudioUrlFallback = (audioUrl) => {
  const link = document.createElement('a');
  link.href = audioUrl;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadAudioFile = async (audioUrl) => {
  const resolvedAudioUrl = resolveAudioUrl(audioUrl);
  if (!resolvedAudioUrl) {
    throw new Error('No audio URL provided');
  }

  try {
    const response = await fetch(resolvedAudioUrl);
    if (!response.ok) {
      throw new Error('Failed to fetch audio file');
    }
    const blob = await response.blob();
    const fileName = resolveAudioFileName(
      resolvedAudioUrl,
      response.headers.get('content-type'),
    );
    triggerBlobDownload(blob, fileName);
    return { success: true, fallback: false };
  } catch (error) {
    Sentry.captureException(error);
    try {
      openAudioUrlFallback(resolvedAudioUrl);
      return { success: true, fallback: true };
    } catch (fallbackError) {
      Sentry.captureException(fallbackError);
      throw fallbackError;
    }
  }
};
